import React, { useState, useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { createAPIEndpoint} from '../api'
import { ENDPOINTS } from '../api/config'
//import error from '../img/negativo.svg';

import ErrorModal, { useErrorHandling } from './ErrorModal';
import Plantilla from './plantillas/Plantilla';
import { ContinuarMasTardeButton } from './ContinuarMasTardeButton';
import { setProgress } from './Progreso';

/**
 * Renders Activacion component
 */

export default function Activacion({ planAcademico, onSelectAnotherPlan, onActivation, showSelectAnotherPlan }) {
    //useEffect(() => { setProgress(10, 'Confirma tu activación'); }, []);

    const [activando, setActivando] = useState(false);
    const { error, clearError, showErrorModal } = useErrorHandling('PA002');

    let selectedPlanInfo = planAcademico;

    const activarUsuario = () => {
        setActivando(true);

        const studentInformationRequest = {
            Matricula: selectedPlanInfo.matricula,
            Grado: selectedPlanInfo.grado,
            Numerodegrado: selectedPlanInfo.numerodegrado,
            Cclinscripcion: selectedPlanInfo.cclinscripcion,
            Campus: selectedPlanInfo.campus,
            institucion: selectedPlanInfo.institucion,
        }

        createAPIEndpoint(ENDPOINTS.active)
            .post(studentInformationRequest)
            .then(res => {
                if (!res || !res.data || res.data.length === 0) {
                    showErrorModal(null, error.serie, '001');
                    return;
                }

                let activacion = res.data[0].resultadoactivacion;
                if (!activacion.valor) {
                    showErrorModal(activacion.mensajeportal, activacion.serie, activacion.numero);
                    return;
                }

                onActivation(res.data[0].planacademico);
            })
            .catch(err => {
                showErrorModal(null, error.serie, '002');
            }).finally(() => {
                setActivando(false);
            });
    };


    return (
        <Container>
            <Plantilla id="3_0_Activacion" planInfo={selectedPlanInfo} />

            <Row>
                <Col className="d-grid gap-2 m-2">
                    <Button variant="primary" disabled={activando ? "disabled" : ""} onClick={() => activarUsuario()}>
                        {activando || <>Aceptar y continuar</>}
                        {activando && <div className="spinner-border spinner-border-sm m-1" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>}
                    </Button>
                </Col>
            </Row>

            {showSelectAnotherPlan && 
                <Row style={{ textAlign: "left" }}>
                    <Col className="d-grid gap-2 m-2">
                        <Button variant='outline-secondary' size='sm' onClick={onSelectAnotherPlan}>
                            Seleccionar otro plan académico
                        </Button>
                    </Col>
                </Row>
            }

            <Row style={{ textAlign: "left" }}>
                <Col className="d-grid gap-2 m-2">
                    <ContinuarMasTardeButton />
                </Col>
            </Row>

            <ErrorModal error={error} onClose={clearError} />
        </Container>
    );
}
